'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.controller:MyProfileCtrl
 * @description
 * # MyProfileCtrl
 * Controller of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp').controller('MyProfileCtrl', ['$scope', '$location', 'Session', function ($scope, $location, Session) {
    if (!Session.getSessionObject().isAuthenticated) {
        $location.url('/');
        return;
    }

    $scope.versionKey = versionKey;

    $scope.profileView = 'updateInfo';
    $scope.changeProfileViewTo = function (view) {
        $scope.profileView = view;
    };

}])
  .controller('MyProfileChangePasswordCtrl', ['$scope', 'Session', function ($scope, Session) {
      $scope.errMsgs = [];
      $scope.successMsg = '';

      $scope.passwordFieldChanged = function () {
          $scope.errMsgs = [];
      };

      $scope.changePassword = function (password, newPassword, confirmPassword) {
          Session.changePassword(password, newPassword, confirmPassword).then(function (response) {
              if (response.data.Changed) {
                  $scope.errMsgs = [];
                  $scope.successMsg = 'Password successfully changed';
              }
              else {
                  $scope.errMsgs = response.data.Errors;
                  $scope.successMsg = '';
              }
          }, function () {
              $scope.errMsgs = ['Password not changed, please try again.'];
              $scope.successMsg = '';
          });
      };
  }])
  .controller('MyProfileUpdateCtrl', ['$scope', 'Session', 'Discipline', 'Position', 'InstitutionService', function ($scope, Session, Discipline, Position, InstitutionService) {
      $scope.errMsg = '';
      $scope.successMsg = '';

      Session.userDetails().then(function () {
          $scope.user = Session.user;
          if ($scope.user.Discipline) {
              //remap the integer to be a string, this will let us select it in the select
              $scope.user.Discipline = $scope.user.Discipline.toString();
          }
          if ($scope.user.Position) {
              //remap the integer to be a string, this will let us select it in the select
              $scope.user.Position = $scope.user.Position.toString();
          }
      });

      Discipline.getDisciplines().then(function () {
          $scope.disciplines = Discipline.disciplines;
      });

      Position.getPositions().then(function () {
          $scope.positions = Position.positions;
      });

      $scope.Institution = {
          Loading: false,
          NoResults: false,
      };

      $scope.searchInstitution = function (text) {
          return InstitutionService.search(text).then(function (response) {
              return response.data;
          });
      };

      $scope.updateUser = function () {

          $scope.profileSubmitted = true;

          if ($scope.updateUserForm.$invalid) {
              return;
          }

          Session.updateUser($scope.user).then(function (response) {
              if (response.data) {
                  $scope.errMsg = '';
                  $scope.successMsg = 'Information Updated';
                  $scope.profileSubmitted = false;
              }
              else {
                  $scope.errMsg = 'Information not updated.';
                  $scope.successMsg = '';
              }
          }, function () {
              $scope.errMsg = 'Information not updated.';
              $scope.successMsg = '';
          });

      };
  }]);
